const TmpCountryMap = {
    TMP_COUNTRY_MAP: "tmpCountryMap",    
}

export default TmpCountryMap